import { CheckBoxOutlineBlank, CheckBoxOutlined } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { OrderStatusEnum } from "commons/enum/order-status";
import { ICatalogueProperties } from "mobx-stores/_models/base";
type OrderStatusProps = {
  status: ICatalogueProperties;
};
export const OrderStatus = ({ status }: OrderStatusProps) => {
  return (
    <Chip
      variant="filled"
      color={
        status.code === OrderStatusEnum.Completed
          ? "success"
          : status.code === OrderStatusEnum.Canceled
          ? "error"
          : "default"
      }
      label={status?.name || ""}
    ></Chip>
  );
};
type OrderCompensatingProps = {
  isCompensating: boolean;
};
export const OrderCompensating = ({
  isCompensating = false,
}: OrderCompensatingProps) => {
  return !isCompensating ? (
    <CheckBoxOutlineBlank></CheckBoxOutlineBlank>
  ) : (
    <CheckBoxOutlined></CheckBoxOutlined>
  );
};
